import * as Sentry from '@sentry/browser';

// Config is injected by resources/views/partials/error-tracking.blade.php (DSN, environment, release).
const config = window.sentryConfig;

if (config && config.dsn) {
    const ownOrigin = window.location.origin.replace(
        /[.*+?^${}()|[\]\\]/g,
        '\\$&'
    );

    // Search engine and shopping crawlers (Storebot, Baiduspider...) run our JavaScript and interrupt its requests half
    // way, which floods the issues with errors no customer ever sees: their events are dropped in beforeSend.
    // Facebook and Instagram in-app browsers are real customers and do not match: only facebookexternalhit, the link
    // preview bot, does.
    const isCrawler =
        /bot|crawl|spider|slurp|lighthouse|headlesschrome|facebookexternalhit|google-inspectiontool|pagespeed|gtmetrix/i.test(
            navigator.userAgent || ''
        );

    Sentry.init({
        dsn: config.dsn,
        environment: config.environment || undefined,
        release: config.release || undefined,
        // Errors only: no tracing, no replay. Customer and order data must never leave the browser.
        sendDefaultPii: false,
        tracesSampleRate: 0,
        // First-party scripts only: third-party widgets (consent banner, tag manager, chat) are noise.
        allowUrls: [new RegExp('^' + ownOrigin)],
        denyUrls: [
            /^chrome-extension:\/\//i,
            /^moz-extension:\/\//i,
            /^safari-extension:\/\//i
        ],
        beforeSend: function (event) {
            return isCrawler ? null : event;
        },
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications.',
            // Cross-origin script failures carry no stack, nothing actionable.
            'Script error.',
            'Script error'
        ]
    });

    // The project is shared by all sites of a platform: the host tells them apart.
    Sentry.setTag('site', window.location.hostname);
    // Where the deployed code comes from: branch, commit, custom_branch, custom_commit.
    Sentry.setTags(config.tags || {});

    // Hook for the Vue editor (resources/js/editor/editor.ts). Vue catches the errors thrown inside components,
    // watchers and lifecycle hooks and, in production, only logs them to the console, so window.onerror never sees
    // them: the editor's errorHandler calls this instead. Same name as in the Print project's bundle.
    // It never throws: it runs inside Vue's errorHandler, where an exception would replace the error being reported.
    window.vg7ReportError = function (error, info) {
        try {
            Sentry.withScope(function (scope) {
                if (info) {
                    // Vue passes a string here (the name of the hook that failed).
                    scope.setExtra('vue_info', String(info));
                }
                // Whatever was thrown reaches Vue, not only Error instances: give Sentry a consistent exception.
                Sentry.captureException(
                    error instanceof Error ? error : new Error(String(error))
                );
            });
        } catch (reportFailure) {
            console.error('vg7ReportError failed', reportFailure);
        }
    };
}
